import _ from 'lodash';
import uuidv4 from 'uuid/v4';
import { COMPONENT_TYPE, COMPONENT_TYPE as TYPE, EXPOSE_DEFAULT_DURATION, TRANSITION_TYPE } from 'common/constants';
import { uuidv4RegExp } from 'common/utils/regexp';

export const CHILDREN_KEY = 'children';

// component types which you cannot remove
export const UNREMOVABLE_TYPES = [TYPE.CARD, TYPE.CONTENT, TYPE.FLOAT_ABOVE, TYPE.FLOAT_BELOW];

// component type for which is able to create some event in a "Flow" screen
export const TYPES_WITH_EVENT = [TYPE.ANSWER, TYPE.BUTTON] as string[];

export const TRAVERSE_TREE_TARGETS = {
	EDITOR: 'editor',
	DEFAULT: 'default',
};

// generate building block _id field
export const generateElementId = (): string => uuidv4();

/**
 * generate building block uiConfig.nodeProps.id field
 * @param id {string} building block _id field value
 * @param name {string} building block name field
 * @return {string}
 */
export const generateNodeId = (id: ReturnType<typeof generateElementId>, name: string): string =>
	`${_.camelCase(name).toLowerCase()}-${id}`;

/**
 * @param id {!string}
 * @returns {*}
 */
export const getElementIdByNodeId = id => _.first(id.match(uuidv4RegExp));

export function getExposeParams(props: {
	exposeEffect?: typeof TRANSITION_TYPE[keyof typeof TRANSITION_TYPE];
	exposeDuration?: number;
	in?: boolean;
	bbType?: string;
}) {
	const exposeEffect = props.exposeEffect || TRANSITION_TYPE.FADE;
	const cardExposeDuration = (props.exposeDuration || 0) * 0.5;

	if (props.bbType === COMPONENT_TYPE.CARD) {
		return {
			duration: cardExposeDuration,
			delay: 0,
			effect: exposeEffect,
		};
	}

	const exposeInDuration = cardExposeDuration * 0.6;
	const exposeOutDuration = exposeInDuration;
	const exposeInDelay = cardExposeDuration - exposeOutDuration;
	const exposeOutDelay = 0;

	return {
		duration: props.in ? exposeInDuration : exposeOutDuration,
		delay: props.in ? exposeInDelay : exposeOutDelay,
		effect: exposeEffect,
	};
}

export function getExposeDuration(value: string) {
	const number = parseFloat(value);
	return (Number.isNaN(number) ? EXPOSE_DEFAULT_DURATION : number) * 1000;
}
